<div class="grid-container">
  <app-plinko-bet-section></app-plinko-bet-section>
  <app-plinko-board [rows]="8"></app-plinko-board>
</div>
